/**
 * Scroll reveal for section headings.
 * ---------------------------------------------------------------------------
 * Adds the ornament element and the reveal class to every wb-* section
 * heading, then fades each one in as it enters the viewport.
 *
 * Done in JS rather than Liquid so it applies to every section at once
 * without editing eighteen files, and so that with JS disabled the headings
 * simply render normally — the CSS only hides them inside a
 * prefers-reduced-motion: no-preference query that this script opts into.
 */

const HEADINGS = [
  '.wb-rail__heading',
  '.wb-tiles__heading',
  '.wb-cmp__heading',
  '.wb-arts__heading',
  '.wb-faq__heading',
  '.wb-cta__heading',
  '.wb-blog__heading',
  '.wb-wish__heading',
  '.wb-chero__heading',
].join(',');

const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

function init() {
  const headings = Array.from(document.querySelectorAll(HEADINGS));
  if (!headings.length) return;

  headings.forEach((heading) => {
    // Skip empty headings — several sections leave the heading blank and lead
    // with the eyebrow instead.
    if (!heading.textContent.trim()) return;

    if (!heading.nextElementSibling?.classList?.contains('wb-heading-ornament')) {
      const ornament = document.createElement('span');
      ornament.className = 'wb-heading-ornament';
      ornament.setAttribute('aria-hidden', 'true');
      heading.insertAdjacentElement('afterend', ornament);
    }
  });

  if (REDUCED.matches || !('IntersectionObserver' in window)) return;

  const targets = headings.filter((h) => h.textContent.trim());
  targets.forEach((h) => h.classList.add('wb-reveal'));

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.1 }
  );

  targets.forEach((h) => observer.observe(h));

  // Anything already in view on load should not wait for a scroll event.
  requestAnimationFrame(() => {
    targets.forEach((h) => {
      if (h.getBoundingClientRect().top < window.innerHeight) {
        h.classList.add('is-visible');
      }
    });
  });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
